// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(2300) FIXME: Duplicate identifier 'Provider'.
class Provider {
   csrf: any
   displayName: any
   enabled: any
   canLoginManually: any
   error: any
   expiry: any
   initialized: any
   loggedIn: any
   refreshInterval: any
   user: any
   summonOnly: boolean
   constructor(displayName: any, canLoginManually = true, summonOnly = false) {
      this.displayName = displayName
      this.loggedIn = false
      this.enabled = false
      this.canLoginManually = canLoginManually
      this.initialized = false
      this.refreshInterval = null
      this.error = null
      this.csrf = ''
      this.user = ''
      this.expiry = 0
      this.summonOnly = summonOnly
   }
}

// @ts-expect-error TS(2300) FIXME: Duplicate identifier 'Feature'.
class Feature {
   activeProvider: any
   description: any
   name: any
   providerUpdateHook: any
   supportedProviders: any
   translation: any
   showInLoginMenu: boolean
   showInMenu: () => boolean
   providers: Provider[] = []
   constructor(name: any, translation = '', description = '', providerUpdateHook = angular.noop) {
      this.name = name
      this.translation = translation
      this.description = description
      this.providerUpdateHook = providerUpdateHook
      this.activeProvider = null
      this.supportedProviders = []
      this.showInLoginMenu = true
      this.showInMenu = this.showFeatureInMenu.bind(this)
   }

   showFeatureInMenu() {
      return this.showInLoginMenu && this.providers.some((p: Provider) => p.enabled)
   }


   // can be used to set (or update params) provider for this feature
   setProvider(provider: any, loginParams: any) {
      const existingProvider = _.find(this.supportedProviders, (p: any) => provider === p.provider)
      if (existingProvider) {
         existingProvider.params = loginParams
      } else {
         this.supportedProviders.push({provider, params: loginParams})
      }
    
      return this.providerUpdateHook()
   }

   getSupportedProviders() {
      return _.map(this.supportedProviders, (p: any) => p.provider)
   }

   loginParamsForProvider(provider: any) {
      const existingProvider = _.find(this.supportedProviders, (p: any) => provider === p.provider)
      if (existingProvider) {
         return existingProvider.params
      } else {
         return null
      }
   }
}

class AuthenticationService {
   $authEvents: any
   $http: any
   $interval: any
   $location: any
   $log: any
   $q: any
   $rootScope: any
   $route: any
   $timeout: any
   $uibModal: any
   $window: any
   alerts: any
   appState: any
   authenticateWithRedirect: any
   authConfigs: any
   configs: any
   i18n: any
   loginInProgress: any
   loginPopup: any
   loginStarted: any
   providers: string[]
   scope: any
   uibModalInstance: any
   searchApiFeature: any
   isAuthenticationEnabled: boolean
   configProviders: any
   isVpnAuthenticated: boolean
   dialogService: DialogService
   constructor($window: any, configs: any, i18n: any, $log: any, $q: any, $location: any, appState: any, $http: any, $rootScope: any, $authEvents: any, $uibModal: any, $timeout: any, $route: any, $interval: any, alertService: any, dialogService: DialogService) {      this.init = this.init.bind(this)
      this.determineProviders = this.determineProviders.bind(this)
      this.registerFeature = this.registerFeature.bind(this)
      this.updateFeaturesWithLoginState = this.updateFeaturesWithLoginState.bind(this)
      this.toggleProviderEnabledBasedOnFeature = this.toggleProviderEnabledBasedOnFeature.bind(this)
      this.setUserNameForProvider = this.setUserNameForProvider.bind(this)
      this.setEmailForProvider = this.setEmailForProvider.bind(this)
      this.setUserNameForBanner = this.setUserNameForBanner.bind(this)
      this.getUserForProvider = this.getUserForProvider.bind(this)
      this.setSierraPatronIdForProvider = this.setSierraPatronIdForProvider.bind(this)
      this.getSierraPatronIdForProvider = this.getSierraPatronIdForProvider.bind(this)
      this.authenticationRouteChangeHandler = this.authenticationRouteChangeHandler.bind(this)
      this.handleRouteErrors = this.handleRouteErrors.bind(this)
      this.notAuthenticatedHandler = this.notAuthenticatedHandler.bind(this)
      this.loginExpiredHandler = this.loginExpiredHandler.bind(this)
      this.logoutSuccessHandler = this.logoutSuccessHandler.bind(this)
      this.checkIfOnAuthRouteAndMoveAway = this.checkIfOnAuthRouteAndMoveAway.bind(this)
      this.loginErrorWithMessageIfOnAuthRoute = this.loginErrorWithMessageIfOnAuthRoute.bind(this)
      this.checkIfValidateRequestNeeded = this.checkIfValidateRequestNeeded.bind(this)
      this.doInitializeProvider = this.doInitializeProvider.bind(this)
      this.formatUrl = this.formatUrl.bind(this)
      this.hookLocalStorage = this.hookLocalStorage.bind(this)
      this.startRefreshTimer = this.startRefreshTimer.bind(this)
      this.stopRefreshTimer = this.stopRefreshTimer.bind(this)
      this.getProviderFromCallback = this.getProviderFromCallback.bind(this)
      this.doValidateAfterCallback = this.doValidateAfterCallback.bind(this)
      this.doRefreshToken = this.doRefreshToken.bind(this)
      this.setAppState = this.setAppState.bind(this)
      this.getAppState = this.getAppState.bind(this)
      this.getAuthState = this.getAuthState.bind(this)
      this.shouldBroadcastAuthstateChange = this.shouldBroadcastAuthstateChange.bind(this)
      this.setAuthState = this.setAuthState.bind(this)
      this.getLoggedInProviderForFeature = this.getLoggedInProviderForFeature.bind(this)
      this.getLoggedInProvidersForFeature = this.getLoggedInProvidersForFeature.bind(this)
      this.isLoggedInForFeature = this.isLoggedInForFeature.bind(this)
      this.providerSupportsFeature = this.providerSupportsFeature.bind(this)
      this.getFeaturesForProvider = this.getFeaturesForProvider.bind(this)
      this.getProvidersForFeature = this.getProvidersForFeature.bind(this)
      this.getProviderForFeature = this.getProviderForFeature.bind(this)
      this.getAuthValue = this.getAuthValue.bind(this)
      this.setAuthValue = this.setAuthValue.bind(this)
      this.updateScopeFromLocalStorage = this.updateScopeFromLocalStorage.bind(this)
      this.isLoggedIn = this.isLoggedIn.bind(this)
      this.login = this.login.bind(this)
      this.logout = this.logout.bind(this)
      this.openPopupWindow = this.openPopupWindow.bind(this)
      this.loginError = this.loginError.bind(this)
      this.logoutAfterExpire = this.logoutAfterExpire.bind(this)
      this.afterLogout = this.afterLogout.bind(this)
      this.clearAuthState = this.clearAuthState.bind(this)
      this.isAuthExpired = this.isAuthExpired.bind(this)
      this.deleteAppState = this.deleteAppState.bind(this)
      this.storeAppState = this.storeAppState.bind(this)
      this.getPreviousAppState = this.getPreviousAppState.bind(this)
      this.optApplyPrevState = this.optApplyPrevState.bind(this)
      this.afterLogIn = this.afterLogIn.bind(this)
      this.loginSuccessHandler = this.loginSuccessHandler.bind(this)
      this.loginToSummonWithSaml = this.loginToSummonWithSaml.bind(this)
      this.closeLoginDialog = this.closeLoginDialog.bind(this)
      this.closeLogoutDialog = this.closeLogoutDialog.bind(this)
      this.checkLogoutHappened = this.checkLogoutHappened.bind(this)
      this.openLogoutDialog = this.openLogoutDialog.bind(this)
      this.getProviderDisplayName = this.getProviderDisplayName.bind(this)
      this.openLoginDialog = this.openLoginDialog.bind(this)
      this.sierraLoginFailedHandler = this.sierraLoginFailedHandler.bind(this)
      this.$window = $window
      this.i18n = i18n
      this.$log = $log
      this.$q = $q
      this.$location = $location
      this.appState = appState
      this.$http = $http
      this.$rootScope = $rootScope
      this.$authEvents = $authEvents
      this.$uibModal = $uibModal
      this.$timeout = $timeout
      this.$route = $route
      this.$interval = $interval
      this.configs = configs
      this.authConfigs = this.configs.data.authentication
      this.alerts = alertService
      this.dialogService = dialogService
      this.alerts.resetAlert('authenticationNotice')
      this.uibModalInstance = null
      this.authenticateWithRedirect = true
      this.configProviders = this.configs.data.savedSearchAndItems.providers
      this.isVpnAuthenticated = this.configs.data.vpnBanner.authenticated

      // Enabled only when authentication is set as enable, or one of the providers is enabled too. Assuming that is Sierra is enabled, either SAML or CAS is too. 
      this.isAuthenticationEnabled = this.authConfigs.enabled || this.configProviders.length || this.configs.data.rtaAvailability.isSierraClient || this.authConfigs.samlConfigurationExists
      
      // loginStarted is used as flag for 'this instance needs to send the 'validate' request'
      // > in case multiple tabs are opened, only 1 needs to validate and send the result to others via localstorage events
      this.loginStarted = false
      this.loginPopup = null
      this.scope = {
         loginUrl: '/auth/:provider',
         logoutUrl: '/auth/:provider/logout',
         refreshUrl: '/auth/:provider/refresh',
         validateUrl: '/auth/:provider/validate',
         // TODO 'provider' can go I think, there is no single logged in provider anymore... - TEST!
         provider: '', // 'cas' by default, then shifts to another provider if loggedIn
         loggedInStatusForBanner: false,
         usernameForBanner: '',
         // features are an administration of which feature supports which provider, 
         // it also provides info for UI display like translation or description
         features: {},
         auth: {
            microsoft: new Provider('Microsoft'),
            google: new Provider('Google'),
            cas: new Provider(this.i18n.translations.LIBRARY_ACCOUNT),
            saml: new Provider(this.authConfigs.samlAlias, true, (this.authConfigs.useSamlForSearchApiAuth && !this.authConfigs.vpnAuthenticated)),
            lti: new Provider('LTI', false, true)
         },
         useSamlForSearchApiAuth: this.authConfigs.useSamlForSearchApiAuth,
         samlForPrivateSite: this.authConfigs.samlForPrivateSite
      }
      this.providers = this.determineProviders()
      this.searchApiFeature = this.registerFeature('searchapi', 'SUMMON')
      this.searchApiFeature.setProvider('lti', {})
      if (this.scope.useSamlForSearchApiAuth && !this.authConfigs.vpnAuthenticated){
         this.searchApiFeature.setProvider('saml', {})
      }
   }

   init() {
      this.$log.debug('authenticationservice init')

      // hook all the relevant global events to deal with auth
      // FYI the log in / out success are emitted by the /auth/redirect endpoint via localStorage events
      this.$rootScope.$on(this.$authEvents.LOGOUTSUCCESS, this.logoutSuccessHandler)
      this.$rootScope.$on(this.$authEvents.LOGINAFTERPOPUP, this.checkIfValidateRequestNeeded)
      this.$rootScope.$on(this.$authEvents.LOGINSUCCESS, this.loginSuccessHandler)
      this.$rootScope.$on(this.$authEvents.LOGOUTAFTERPOPUP, (event: any, data: any) => this.afterLogout(data.provider, false))

      // auth interceptor fires this when encountering a 401
      this.$rootScope.$on(this.$authEvents.NOTAUTHENTICATED, this.notAuthenticatedHandler)
      this.$rootScope.$on(this.$authEvents.LOGINEXPIRED, this.loginExpiredHandler)

      this.$rootScope.$on(this.$authEvents.SIERRA_LOGIN_FAILED, this.sierraLoginFailedHandler)

      this.$rootScope.$on('$routeChangeStart', this.authenticationRouteChangeHandler)
      this.$rootScope.$on('$routeChangeError', this.handleRouteErrors)

      this.hookLocalStorage()
      this.loginStarted = false
      // only use redirect for mobile devices (excluding safari on ios)
      this.authenticateWithRedirect = this.authConfigs.onlyUseRedirect || (this.$window.bowser.mobile && !(this.$window.bowser.ios && this.$window.bowser.safari))

      // update features with active provider info
      return this.updateFeaturesWithLoginState()
   }

   sierraLoginFailedHandler(event: any, data: any) {
      this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOG_IN_ERROR_SIERRA, 'danger', this.getProviderDisplayName(data.provider), false)
   }

   /**
    * Ensures that the user is authenticated for the given feature ---> RA.
    * @param feature
    * @param redirectUrl
    */
   ensureAuthenticatedRAUser(redirectUrl: string): Promise<any> {
      const allProviderInits = _.map(this.providers, (p: any) => this.doInitializeProvider(p));
      const feature = 'research_assistant';
      return this.$q.all(allProviderInits).then(() => {
         const isLoggedIn = this.isLoggedInForFeature(feature);
         const skip = this.shouldSkipAuthentication(feature);

         if (!isLoggedIn && !skip) {
            return this.openLoginDialog(feature, redirectUrl);
         } else {
            return this.$location.path(feature)
         }
      });
   }


   // determine what providers have been set up for summon, regardless of feature
   determineProviders() : string[] {
      const providers = []
      if (this.authConfigs.casConfigurationExists) {
         providers.push('cas')
      }
      if (this.authConfigs.samlConfigurationExists) {
         providers.push('saml')
      }
      if (this.authConfigs.ltiConfigurationExists) {
         providers.push('lti')
      }
      //oAuthProviders are configured for summon site globally rather than per client
      _.map(this.authConfigs.oAuthProviders, (p: any) => providers.push(p.toLowerCase()))
    
      for (var provider in this.scope.auth) {
         var providerInfo = this.scope.auth[provider]
         providerInfo.enabled = providers.includes(provider)
      }

      return providers
   }

   // this handles taking care of some state for a feature, like which providers it supports logging in for
   // and some config for that provider, like in the case of google login for cloud Storage, which scope it should use
   registerFeature(name: any, translationId: any, descriptionId?: any) {
      if (!translationId) {
         throw new Error(`Feature ${name} needs a translation ID!`)
      }
      if (!descriptionId) {
         descriptionId = `${translationId}_DESCRIPTION`
      }
      const feature = new Feature(name, this.i18n.translations[translationId], this.i18n.translations[descriptionId], this.updateFeaturesWithLoginState)
      this.scope.features[name] = feature
      this.updateFeaturesWithLoginState()
      return feature
   }

   updateFeaturesWithLoginState() {
      // first make sure all providers are enabled/disabled based on other providers login state
      this.toggleProviderEnabledBasedOnFeature()
      for (var _ in this.scope.features) {
         var feature = this.scope.features[_]
         feature.providers = []
         for (var p of feature.getSupportedProviders()) {
            var provider = this.scope.auth[p]
            if(provider) {
               // if there is an activeProvider, only that provider is active, and otherwise they are active when the provider itself is enabled
               var isEnabled = feature.activeProvider ? feature.activeProvider === p : provider.enabled && provider.canLoginManually
               feature.providers.push({ name: p, displayName: provider.displayName, loggedIn: provider.loggedIn, enabled: isEnabled })
            }
         }
      }

      return this.scope.features
   }

   // this will disable all other providers for a specific feature when there is a loggedIn provider
   // note that there might be edge cases like: 
   // - savedsearch has google & saml
   // - sierra has cas & saml
   // what happens when you log in with google for savesearch, but with saml for sierra
   // now we _could_ authenticate for savesearch with either google or saml - so we need to enforce that this is not changed by accident
   toggleProviderEnabledBasedOnFeature() {
      return (() => {
         const result = []
         for (var feature in this.scope.features) {
            var featureInfo = this.scope.features[feature]
            var activeProvider = this.getLoggedInProviderForFeature(feature)
            if (activeProvider) {
               result.push(featureInfo.activeProvider = activeProvider)
            } else {
               result.push(featureInfo.activeProvider = null)
            }
         }
         return result
      })()
   }

   // sometimes user info is not retrieved directly by idp, but external service
   // convenience methods for setting those:
   setUserNameForProvider(name: any, provider: any) {
      return this.scope.auth[provider].username = name
   }

   setEmailForProvider(email: any, provider: any) {
      return this.scope.auth[provider].email = email
   }

   setUserNameForBanner(name: any) {
      return this.scope.usernameForBanner = name
   }

   getUserForProvider(provider: any) {
      return this.scope.auth[provider].user
   }

   getSummonOnlyForProvider(provider: string) {
      return this.scope.auth[provider].summonOnly
   }

   providerCanLoginManually(provider: string) {
      return this.scope.auth[provider].canLoginManually
   }

   setSierraPatronIdForProvider(patronId: any, provider: any) {
      return this.scope.auth[provider].sierraPatronId = patronId
   }

   getSierraPatronIdForProvider(provider: any) {
      return this.scope.auth[provider].sierraPatronId
   }

   isLoggedIntoSummonApi() {
      if (this.isLoggedInForFeature('searchapi')) return true
      if (!this.scope.useSamlForSearchApiAuth) return false
      return this.scope.auth.saml.loggedIn
   }

   // this does the following every time the route changes
   // 1. Starts initialize (promise / async) for all providers (so we can be sure if user is logged in or not)
   //    The providers async init function resolves to an object with a result (initialized or not)
   // 2. Check if the next route (where the user wants to go) is only accessible when authenticated (defined in router config, auth: true)
   // 3. Assigns the result of all the initializations to the resolve function of the route the user wants to go: @$route.routes[@$location.path()].resolve
   //    this is a special thing in angularjs routes, which performs the route change when the promise is resolved
   authenticationRouteChangeHandler(event: any, next: any, current: any) {

      const nextPath = next?.originalPath || this.$location.path();

      // if the next path is research_assistant, we don't need to do anything here
      if (nextPath === '/research_assistant') {
         return;
      }

      // grabbing provider from URL in case of redirect flow, but very likely to be empty
      const provider = this.getProviderFromCallback()
      const allProviderInits = _.map(this.providers, (p: any) => this.doInitializeProvider(p))
      const initPromise = this.$q.all(allProviderInits)

      // nextRoute is the route the user wants to go
      const nextRoute = this.$route.routes[this.$location.path()]
      this.$log.debug(`routeChangeStart, provider from URL=${provider}, nextroute=${nextRoute}`)

      // check if auth is required for navigating to the route and cancel navigation if is not logged in.
      if (nextRoute?.auth) {
         const redirectUrl = this.$location.absUrl()

         // this .resolve takes an object with { string: function } where the function can return a promise. The route will then wait until the promise is resolved
         nextRoute.resolve = nextRoute.resolve || {}
         return nextRoute.resolve.auth = () => {
            return initPromise
               .then((result: any) => {
                  this.$log.debug('provider init done, result', result)
                  const isLoggedIn = this.isLoggedInForFeature(nextRoute.feature)
                  const skipAuthentication = this.shouldSkipAuthentication(nextRoute.feature)
                  if (!isLoggedIn && !skipAuthentication) {
                     return this.$q.reject({feature: nextRoute.feature, notAuthenticated: true, providers: this.getProvidersForFeature(nextRoute.feature), redirectUrl })
                  }
               }).catch((err: any) => {
                  return this.$q.reject({feature: nextRoute.feature, notAuthenticated: true, providers: this.getProvidersForFeature(nextRoute.feature), redirectUrl })
               })
         }
      }
   }

   shouldSkipAuthentication(feature: string) {
      if(feature == 'research_assistant') {
         return this.isVpnAuthenticated // with research assistant, if vpn is enabled, authentication is not required
      }
      return false
   }
   // in the auth-specific $routeChangeStart handler (authenticationRouteChangeHandler) the route gets a promise assigned to it.
   // if this resolves to an error, this handler opens the login dialog since the user is not authenticated
   handleRouteErrors(event: any, current: any, previous: any, reason: any) {
      if (reason.notAuthenticated) {
         this.$log.debug('Not authenticated error, opening login dialog', reason)
         event.preventDefault()
         return this.openLoginDialog(reason.feature, reason.redirectUrl).catch((err: any) => {
            return this.checkIfOnAuthRouteAndMoveAway()
         })
      }
   }

   notAuthenticatedHandler(event: any, data: any) {
      this.loginError(data.provider, {msg: this.i18n.translations.AUTHENTICATION_ERROR_NOT_AUTHENTICATED})
      this.updateFeaturesWithLoginState()
      return this.checkIfOnAuthRouteAndMoveAway()
   }

   loginExpiredHandler(event: any, data: any) {
      // only show error message if redirect necessary, otherwise message upon clicking auth links/actions will be sufficient
      this.loginErrorWithMessageIfOnAuthRoute(data.provider, {msg: this.i18n.translations.LOG_IN_EXPIRED})
      this.updateFeaturesWithLoginState()
      return this.checkIfOnAuthRouteAndMoveAway()
   }

   logoutSuccessHandler(event: any, data: any) {
      if ((data.previousState !== this.$authEvents.UNKNOWN) && (data.previousState !== this.$authEvents.LOGINEXPIRED)
         && (data.previousState !== this.$authEvents.LOGOUTAFTEREXPIRED) && (data.previousState !== this.$authEvents.SILENTLOGOUTINPROGRESS)) {
         this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOGGED_OUT_SUCCESS, 'success', this.getProviderDisplayName(data.provider))
      }

      this.updateFeaturesWithLoginState()
      return this.checkIfOnAuthRouteAndMoveAway()
   }

   // makes sure no authenticated pages are left opened after logout
   checkIfOnAuthRouteAndMoveAway() {
      const currentRoute = this.$route.routes[this.$location.path()]
      if (currentRoute?.auth) {
         return this.$location.path('/') // this changes path, but leaves 'query params' e.a. search()
      }
   }

   // handles error but only shows alert if route change needed
   loginErrorWithMessageIfOnAuthRoute(provider: any, messageObject: any)  {
      const currentRoute = this.$route.routes[this.$location.path()]
      if (currentRoute?.auth) {
         return this.loginError(provider, messageObject)
      } else {
         const noAlert = true
         return this.loginError(provider, messageObject, noAlert)
      }
   }
   // this is called after a popup login by the localStorage hook
   // we set a scope variable to true on login, so we don't get a infinite loop
   checkIfValidateRequestNeeded(event: any, data: any) {
      if (this.loginStarted) {
         this.loginStarted = false
         return this.doValidateAfterCallback(data.provider)
            .then(() => {
               // after 'loginStarted' detected, we want to show the login success
               this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOG_IN_SUCCESS, 'success', this.getProviderDisplayName(data.provider), false)
               return this.$route.reload()
            })
      }
   }

   // Returns a promise that resolves to an object containing initialization status
   // checks if
   //  1. login is in progress (then a validate is needed)
   //  2. login is succes (then do a refresh of auth stuff to be sure we are in sync)
   //  3. otherwise log out, since the other states cannot be handled by this provider
   doInitializeProvider(provider: any) {
      if (this.scope.auth[provider].initialized) {
         return this.$q.resolve({provider, result: 'already_initialized'})
      }

      this.scope.auth[provider].initialized = true
      const authState = this.getAuthState(provider)
      this.$log.debug(`doInitializeProvider '${provider}', current state=${authState} (will perform auth checks now)`)

      // after page refresh, we might have correct credentials in appstate, or we just got redirected, and need to validate
      if (authState === this.$authEvents.LOGININPROGRESS
         || authState === this.$authEvents.LOGINAFTERREDIRECT
         || provider === 'lti'
         || (provider === 'saml' && this.scope.samlForPrivateSite)
      ) {
         this.doValidateAfterCallback(provider).then((res: any) => {
            
            // eslint-disable-next-line no-console
            console.log(res)
            // only after 'login in progress' we want to show the login success, other login places are 'refreshes' and can be strange for use to see this toast popping up
            return this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOG_IN_SUCCESS, 'success', this.getProviderDisplayName(provider))
         }).catch((err: any) => {
            //eslint-disable-next-line no-console
            console.error(err)
         })
      } 
      
      //added else here to avoid multiple calls to validate after callback, which can cause issues with multiple toasts popping up and multiple refreshes happening, since validate after callback also calls doInitializeProvider at the end of the flow
      //with else - only one path executes - either validate OR refresh, but not both
      else if (authState === this.$authEvents.LOGINSUCCESS) {
      // force refresh, but also throw the event LOGINSUCCESS again after it's done.
      // this event should be thrown again since this logic might be executed after page refresh when the user was already logged in
      // some providers listen for the LOGINSUCCESS event to initialize, like getting user info (sierra) or savedsearches (summonuserservice)
         return this.doRefreshToken(provider, 0, true)
            .then(() => {
               return this.setAuthState(provider, this.$authEvents.LOGINSUCCESS, true)
            })

      } else if (authState === this.$authEvents.LOGOUTINPROGRESS || authState === this.$authEvents.SILENTLOGOUTINPROGRESS) {
         this.afterLogout(provider, true)
      } else if (this.isLoggedIn(provider)) {
         this.afterLogIn(provider, null, true)
      } else {
         this.afterLogout(provider)
      }

      return this.$q.resolve({provider, result: 'initialized'})
   }

   formatUrl(provider: any, type: any, includeHost = false) {
      let url = this.scope[type].replace(':provider', provider)
      if (includeHost) {
         let port = ''
         if (this.$location.port() !== '80') {
            port = `:${this.$location.port()}`
         }

         url = `${this.$location.protocol()}://${this.$location.host()}${port}${url}`
      }
      return url
   }

   hookLocalStorage() {
      return this.$window.addEventListener('storage', (data: any) => {
         if (!data.key) return

         let provider = null
         if (data.key.indexOf('summon_auth_state_') === 0) {
            provider = data.key.replace('summon_auth_state_', '')
         // 'summon_app_state' stores global application/UI state, not an auth provider,
         // so its updates must not trigger authentication provider refresh logic.
         } else if (data.key.indexOf('summon_') === 0 && data.key !== 'summon_app_state') {
            provider = data.key.replace('summon_', '')
         }

         if (provider) {
            const oldVal = data.oldValue
            const newVal = data.newValue
            this.$log.debug(`state change, provider=${provider}, old=${oldVal}, new=${newVal}, from store=${this.getAuthState(provider)}`)
            return this.updateScopeFromLocalStorage(provider)
         }
      })
   }

   startRefreshTimer(provider: any, interval = this.authConfigs.sessionSeconds - 60) {
      if (this.scope.auth[provider].refreshInterval) {
         this.$log.debug('timer already started, not starting one again')
         return
      }

      if (interval < 60) {
         this.$log.debug('reset interval to 60, it was too small', interval)
         interval = 60
      }

      this.$log.debug(`starting authentication refresh timer for ${provider} interval=${interval}`)
      this.stopRefreshTimer(provider)
      const intervalHandler = () => {
         this.$log.debug(`- running ${provider} authentication refresh timer...`)
         return this.doRefreshToken(provider, interval, true).catch((err: any) => {
            return this.stopRefreshTimer(provider, err.error)
         })
      }

      return this.scope.auth[provider].refreshInterval = this.$interval(intervalHandler, interval * 1000) // times 1000 since it is milliseconds
   }

   stopRefreshTimer(provider: any, reason = "") {
      if (reason) {
         this.$log.debug(`stopping authentication refresh timer for ${provider}: ${reason}`)
      }
      if (this.scope.auth[provider] && this.scope.auth[provider].refreshInterval) {
         this.$interval.cancel(this.scope.auth[provider].refreshInterval)
         return this.scope.auth[provider].refreshInterval = null
      }
   }

   getProviderFromCallback() {
      const urlParams = this.$location.search()
      return urlParams.auth_provider
   }

   // ===============================
   // Microsoft Auth Error Utilities
   // ===============================

   private extractAadstsCode(text: string): string | null {
   if (!text) return null;
   const m = text.match(/AADSTS(\d{5})/i);
   return m?.[1] ?? null;
   }

   private classifyMicrosoftAuthFailure(
   rawText: string,
   aadsts: string | null,
   data: any
   ): 'conditional_access' | 'interaction_required' | 'app_config' | 'unknown' {
   const t = (rawText || '').toLowerCase();

   const interaction =
      data?.error === 'interaction_required' ||
      data?.error === 'login_required' ||
      data?.error === 'consent_required' ||
      t.includes('interaction required') ||
      t.includes('login required') ||
      t.includes('consent required') ||
      t.includes('multi-factor') ||
      t.includes('mfa');

   const conditionalAccess =
      t.includes('conditional access') ||
      t.includes('does not meet the criteria') ||
      t.includes('restricted by your admin') ||
      t.includes('compliant') ||
      (aadsts !== null && aadsts.startsWith('53')); // many CA/device/policy-related errors are 53xxx

   const configIssue =
      t.includes('redirect uri') ||
      t.includes('invalid client') ||
      t.includes('unauthorized_client') ||
      (t.includes('application') && t.includes('not found'));

   if (conditionalAccess) return 'conditional_access';
   if (interaction) return 'interaction_required';
   if (configIssue) return 'app_config';
   return 'unknown';
   }

   private buildAuthFailureMessage(provider: string, err: any): { msg: string; details?: any } {
   const fallback = { msg: this.i18n.translations.AUTHENTICATION_ERROR_REFRESH_ERROR, details: err };
   if (provider !== 'microsoft') return fallback;

   const data = err?.data || err?.response?.data || {};

   // ------------------------------------------------------------
   // 1) Cookie/session establishment problems (handle FIRST)
   // ------------------------------------------------------------
   const reason = data?.reason;
   const msgText = (data?.msg || data?.description || '').toString();

   const cookieMissing =
      reason === 'cookie_missing_on_validate' ||
      (data?.error === 'not_authenticated' && /cookie/i.test(msgText)) ||
      (data?.error === 'not_authenticated' && /no authentication token found/i.test(msgText));

   if (cookieMissing) {
      return {
         msg:
         `Microsoft sign-in was successful, but access could not be completed. ` +
         `The browser could not use the required sign-in cookie, which is often caused by organizational security policies or browser privacy settings. ` +
         `Please contact your IT administrator for assistance.`,

         details: {
         reason,
         cookie_keys: data?.debug?.cookie_keys,
         debug: data?.debug,
         },
      };
   }

   // ------------------------------------------------------------
   // 2) Parse raw upstream text and detect AADSTS
   // ------------------------------------------------------------
   const rawText =
      data?.error_description ||
      data?.message ||
      msgText ||
      (typeof data === 'string' ? data : '') ||
      (typeof err?.data === 'string' ? err.data : '') ||
      '';

   const aadsts =
      data?.aadsts ||
      data?.upstream?.aadsts ||
      this.extractAadstsCode(rawText);

   const kind = this.classifyMicrosoftAuthFailure(rawText, aadsts, data);

   const details = {
      aadsts,
      request_id: data?.request_id || data?.upstream?.request_id,
      correlation_id: data?.correlation_id || data?.upstream?.correlation_id,
      timestamp: data?.timestamp || data?.upstream?.timestamp,
      // keep a little raw text for debugging (optional; strip if sensitive)
      raw: rawText ? rawText.slice(0, 500) : undefined,
   };

   // ------------------------------------------------------------
   // 3) User-facing messages by classification
   // ------------------------------------------------------------
   if (kind === 'conditional_access') {
      const suffix = aadsts ? ` (AADSTS${aadsts})` : '';
      return {
         msg:
         `Microsoft sign-in is blocked by your organization’s access policy${suffix}. ` +
         `This is typically caused by Conditional Access restrictions (device, app, location, or compliance). ` +
         `Please contact your IT administrator and ask them to review Entra ID sign-in logs for this attempt.`,
         details,
      };
   }

   if (kind === 'interaction_required') {
      return {
         msg:
         `Microsoft sign-in requires additional interaction (such as MFA, consent, or account selection). ` +
         `Please try signing in again and complete any prompts that appear.`,
         details,
      };
   }

   if (kind === 'app_config') {
      return {
         msg:
         `Microsoft sign-in failed due to an application configuration issue. ` +
         `Please contact support and include the troubleshooting details (request/correlation ID and timestamp) from this screen.`,
         details,
      };
   }

   return {
      msg:
         `Microsoft sign-in could not be completed. ` +
         `This can be caused by organizational policies, account restrictions, or silent sign-in behavior. ` +
         `Please try again or contact your IT administrator for assistance.`,
      details,
   };
   }


   // after external login, Summon redirects back to the UI, and we got a token from the external auth provider.
   // This token needs validating in the application (CAS / SAML flow)
   // if the /validate $http.post returns OK, we're logged in
   doValidateAfterCallback(provider: any, neverShowError?: boolean) {
      const deferred = this.$q.defer()

      this.$log.debug('Validate after callback ' + provider)
      if (provider == null) {
         provider = this.getProviderFromCallback()
      }

      if (provider != null) {
         this.$http.post(this.formatUrl(provider, 'validateUrl'))
            .then((data: any) => {
               // normalize data format
               this.$log.debug('validate callback success', data.data)
               data = {
                  user: data.data.uid,
                  expiry: data.data.expiry,
                  csrf: data.data.csrf,
                  provider,
                  access_token: data.data.access_token,
                  access_expiry: data.data.access_expiry,
                  display_name: data.data.display_name
               }
               this.afterLogIn(provider, data)
               return deferred.resolve({provider, result: 'validate_success'})
               }).catch((err: any) => {
                  const backendErrorMessage = err?.data?.msg || err?.data?.description;
                  if (provider !== 'lti' && !(provider === 'saml' && this.scope.samlForPrivateSite)) { // lti auth evaluated always, no message needed if not present
                     this.afterLogout(provider, false);
                     const msgObj = this.buildAuthFailureMessage(provider, err);
                     this.loginError(provider, {msg: msgObj.msg || backendErrorMessage, error: msgObj.details || err});
                  }
                  return deferred.reject({ provider, result: 'validate_error', error: err });
            })
      } else {
         deferred.reject({provider, result: 'validate_error', error: 'no provider provided' })
      }

      return deferred.promise
   }

   // calls the refresh endpoint to update expiry value and corresponding csrf
   // the cookie is updated and the local scope is updated in the .then() handler of the http request
   doRefreshToken(provider: any, refreshIfExpiresInLessThenSeconds = 300, forceRefresh = false) {
      const deferred = this.$q.defer()
      this.$log.debug(`doRefreshToken for '${provider}, refresh seconds: ${refreshIfExpiresInLessThenSeconds}, force=${forceRefresh}`)
      const csrf = this.getAuthValue(provider, 'csrf')
      if (forceRefresh || this.isAuthExpired(provider, refreshIfExpiresInLessThenSeconds)) {
         if (this.getAuthState(provider) === this.$authEvents.LOGINEXPIRED) {
            this.logoutAfterExpire(provider)
            deferred.reject({ error: 'login expired, cannot refresh token' })
         } else {
            this.$http.get(this.formatUrl(provider, 'refreshUrl'), {
               headers: {
                  'X-CSRF-Token': csrf, 
               }
            }).then((data: any) => {
               this.$log.debug('refresh token successful', data.data)
               // normalize data format
               data = {
                  user: data.data.uid,
                  expiry: data.data.expiry,
                  csrf: data.data.csrf,
                  provider,
                  access_token: data.data.access_token,
                  access_expiry: data.data.access_expiry,
                  display_name: data.data.display_name
               }
               this.afterLogIn(provider, data, true)
               return deferred.resolve(data)
            }).catch((err: any) => {
               this.$log.error('update token error, logging out', err)
               this.afterLogout(provider)
               const msgObj = this.buildAuthFailureMessage(provider, err);
               this.loginError(provider, { msg: msgObj.msg, error: msgObj.details || err });
               return deferred.reject({ error: 'refresh error, not logged in', original: err})
            })
         }
      } else {
         this.$log.debug(`refreshing token not necessary yet (still within ${refreshIfExpiresInLessThenSeconds})`)
         const data = {
            // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
            user: this.getAuthState(provider, 'user'),
            // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
            expiry: this.getAuthState(provider, 'expiry'),
            // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
            csrf: this.getAuthState(provider, 'csrf'),
            provider
         }
         deferred.resolve(data)
      }

      return deferred.promise
   }

   setAppState(state: any) {
      if (state === null) {
         return this.$window.localStorage.setItem('summon_app_state', "{}")
      } else {
         return this.$window.localStorage.setItem('summon_app_state', state)
      }
   }

   getAppState() {
      return this.$window.localStorage.getItem('summon_app_state')
   }

   // does not use existing storageservice, that encapsulates everything in a 'values' object
   // this makes reacting on storage events difficult. using native implementation is easier here
   getAuthState(provider: any) {
      // this is a separate entry in the localstorage so we can react on it in other tabs
      // the rest of relevant state is stored in other entries
      let needle
      const state = this.$window.localStorage.getItem('summon_auth_state_' + provider)
      if ((needle = state, _.values(this.$authEvents).includes(needle))) {
         return state
      } else {
         this.$log.debug('GetAuthstate got empty auth state, returning UNKNOWN', state)
         return this.$authEvents.UNKNOWN
      }
   }

   shouldBroadcastAuthstateChange(currentState: any, state: any, forceBroadcast: any) {
      if (forceBroadcast) {
         return forceBroadcast
      } else {
         return (currentState !== state) && (currentState !== this.$authEvents.UNKNOWN)
      }
   }

   setAuthState(provider: any, state: any, forceBroadcast = false) {
      let needle
      this.$log.debug('setAuthState for ' + provider + ' state: ' + state)
      if ((needle = state, !_.values(this.$authEvents).includes(needle))) {
         throw new Error(`Trying to set invalid auth state '${state}'`)
      }

      const currentState = this.getAuthState(provider)
      if (state === this.$authEvents.LOGINSUCCESS) {
         this.scope.auth[provider].loggedIn = true
      } else {
         this.scope.auth[provider].loggedIn = false
      }

      this.$window.localStorage.setItem(`summon_auth_state_${provider}`, state)
      if (this.shouldBroadcastAuthstateChange(currentState, state, forceBroadcast)) {
         this.$log.debug(`setAuthState - broadcasting state=${state}, provider=${provider}, forced?=${forceBroadcast}`)
         return this.$rootScope.$broadcast(state, { provider, forced: forceBroadcast, previousState: currentState })
      }
   }

   // returns first loggedin provider found for feature or null if there are none
   getLoggedInProviderForFeature(feature: any) {
      const validProviders = this.getLoggedInProvidersForFeature(feature)
      if (!validProviders.length) {
         return null
      }
      return validProviders[0]
   }

   getLoggedInProvidersForFeature(feature: any) {
      const supportedProviders = (_.filter(this.providers, (provider: any) => this.scope.auth[provider].loggedIn && this.providerSupportsFeature(provider, feature)))
      if (this.scope.features[feature] && this.scope.features[feature].activeProvider) {
         return _.filter(supportedProviders, (f: any) => f === this.scope.features[feature].activeProvider)
      } else { 
         return supportedProviders
      }
   }

   isLoggedInForFeature(feature: any) {
      return !!this.getLoggedInProviderForFeature(feature)
   }

   providerSupportsFeature(provider: any, feature: any) {
      return _.includes(this.scope.features[feature]?.getSupportedProviders(), provider)
   }

   getFeaturesForProvider(provider: any) {
      const features = []
      for (var feature of _.keys(this.scope.features)) {
         if (this.providerSupportsFeature(provider, feature)) {
            features.push(this.scope.features[feature])
         }
      }
      return features
   }

   getProvidersForFeature(feature: any) : string[] | null {
      const p = _.filter(this.providers, (provider: any) => this.providerSupportsFeature(provider, feature))
      if (p.length === 0) {
         return null
      } else {
         return p
      }
   }

   getProviderForFeature(feature: any) {
      const p = this.getProvidersForFeature(feature)
      if (p == null || p.length === 0) {
         return null
      } else {
         return p[0]
      }
   }

   // returns null in case of error or unknown 'name'
   getAuthValue(provider: any, name: any) {
      const val = this.$window.localStorage.getItem(`summon_${provider}`)
      try {
         if (val) {
            const parsed = JSON.parse(val)
            if ((typeof parsed === 'object') && name in parsed) {
               return parsed[name]
            }
         }
      } catch (err) { // the catch is mostly there for the json parse
         this.$log.error('getAuthValue error', err)
         return null
      }

      return null
   }

   setAuthValue(provider: any, val: any) {
      if (val === null) {
         return this.$window.localStorage.removeItem(`summon_${provider}`)
      } else {
         return this.$window.localStorage.setItem(`summon_${provider}`, JSON.stringify(val))
      }
   }

   updateScopeFromLocalStorage(provider: any) {
      const authState =  this.getAuthState(provider)
      if ((authState !== this.$authEvents.LOGINAFTERREDIRECT) && (authState !== this.$authEvents.LOGINAFTERPOPUP) && (authState !== this.$authEvents.UNKNOWN)) {
         this.scope.auth[provider].expiry = this.getAuthValue(provider, 'expiry')
         this.scope.auth[provider].user = this.getAuthValue(provider, 'user')
         this.scope.auth[provider].csrf = this.getAuthValue(provider, 'csrf')
         this.scope.auth[provider].accessToken = this.getAuthValue(provider,'access_token')
         this.scope.auth[provider].accessExpiry = this.getAuthValue(provider,'access_expiry')
         this.scope.auth[provider].username = this.getAuthValue(provider,'display_name')
         this.scope.auth[provider].email = this.getAuthValue(provider,'email')
         this.scope.auth[provider].loggedIn = authState === this.$authEvents.LOGINSUCCESS
      }

      return this.$timeout(() => {
      // the $broadcast is here, and in 'setAuthState, should maybe one single place?'
         this.$log.debug('broadcasting ', authState, {provider})
         this.$rootScope.$broadcast('csrfTokenRefreshed', {provider, csrf: this.scope.auth[provider].csrf, user: this.scope.auth[provider].user})
         //if only syncing from storage, broadcast needs to know to avoid reloading window
         return this.$rootScope.$broadcast(authState, { provider, fromStorageSync: true })
      }
      , 100)
   }

   isLoggedIn(provider: any) {
      if (!provider) { // if provider has not been defined, user has not logged in with any provider
         return false
      }
      this.$log.debug('islogged in called for ' + provider)
      const authState = this.getAuthState(provider)
      if ((authState === this.$authEvents.LOGOUTINPROGRESS) || (authState === this.$authEvents.LOGOUTSUCCESS) || (authState === this.$authEvents.SILENTLOGOUTINPROGRESS)) {
         return false
      }
      if (this.isAuthExpired(provider, 0)) {
         return false
      }

      return this.scope.auth[provider].loggedIn
   }

   login(feature: any, provider: any, redirectUrl = this.$window.location.href) {
      if (this.scope.features[feature].enabled === false) {
         this.loginError(provider, 'Feature not supported for this provider')
         return
      }
      if (this.scope.features[feature].activeProvider) {
      // there is already a provider active for this feature, throwing error
         this.loginError(provider, 'Already an active provider for this feature')
         return
      }

      this.loginInProgress = true
      // this redirects to the auth login
      this.setAuthState(provider, this.$authEvents.LOGININPROGRESS)
      const loginUrl = this.formatUrl(provider, 'loginUrl', true)
      this.loginStarted = false
      const loginParams = this.scope.features[feature].loginParamsForProvider(provider)
      let queryParams = ''
      if (loginParams) {
         queryParams = '&' + $.param(loginParams)
      }
      // @afterLogin is called on init after detecting a state change in the localstorage
      if (this.authenticateWithRedirect) {
         this.$log.debug('*** login start for ' + provider + ' redirect to: ' + redirectUrl)
         this.storeAppState()
         return this.$window.location.href = `${loginUrl}?redirect=${encodeURIComponent(redirectUrl)}&source=redirect` + queryParams
      } else {
         this.$log.debug('*** login start for ' + provider)
         // for saml we need a static loginUrl per client -- saml idp checks ACS against our metadata
         const popupLoginUrl = provider === 'saml' ? loginUrl : `${loginUrl}?source=popup&redirect=${encodeURIComponent(redirectUrl)}` + queryParams
         this.openPopupWindow(popupLoginUrl).then((res: string) => {
            if (this.getAuthState(provider) === this.$authEvents.LOGININPROGRESS && res === 'canceled') {
               this.setAuthState(provider, this.$authEvents.LOGINCANCELED)
            }
         })
         return this.loginStarted = true
      }
   }

   loginToSummonWithSaml() {
      this.login('searchapi', 'saml')
   }

   logout(feature: any, provider: any, redirectUrl: any, summonOnly = false, showToast = true) {
      let redirect = ''
      if (redirectUrl) { 
         redirect = `&redirect=${encodeURIComponent(redirectUrl)}`
      }
      this.alerts.resetToastAlert('authenticationNotice') // remove any older alerts about auth before creating new event
      this.setAuthState(provider, showToast ? this.$authEvents.LOGOUTINPROGRESS : this.$authEvents.SILENTLOGOUTINPROGRESS)
      return this.$http.get(`${this.formatUrl(provider, 'logoutUrl')}?localOnly=${summonOnly}${redirect}`)
         .then((response: any) => {
            const data = response.data;
      
            // Open logout_url (e.g., Google Logout page) if provided
            if (data.logout_url) {
               window.open(data.logout_url, '_blank');
            }
            this.redirectIfRedirectUrl(response.data.redirect_url)
         })
         .finally(() => {
            this.afterLogout(provider, showToast)
            if (summonOnly) {
               // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
               return this.closeLogoutDialog(feature, provider)
            } 
         })
   }

   redirectIfRedirectUrl(redirectUrl: string){
      if(redirectUrl) {
         this.$window.location.replace(redirectUrl)
      }
   }

   openPopupWindow(url: any) {
      const deferred = this.$q.defer()
      const win = angular.element(this.$window)

      if ((this.loginPopup === null) || this.loginPopup.closed) {
         const height = win.height()
         const width = win.width()
         if((width || width === 0) && (height || height === 0)){
            this.loginPopup = this.$window.open(url, 'SummonAuthenticatePopup', `location=no,width=${width - 60},height=${height - 60},left=30,top=30`)
         }

         // this checks if the window is closed again and resolves promise
         const windowPollHandler = () => {
            if (this.loginPopup.closed) {
               this.$interval.cancel(windowPoller)
               this.$log.debug('popup window closed: ', url)
               return deferred.resolve('canceled')
            }
         }

         var windowPoller = this.$interval(windowPollHandler, 1000)
      } else {
         this.loginPopup.focus()
      }

      return deferred.promise
   }

   loginError(provider: any, err: any, noAlert = false) {
      if (!noAlert) {
         this.$log.error(err)
         if (err != null) {
            this.alerts.toastAlert('authenticationNotice', this.i18n.translate(this.i18n.translations.LOGGED_OUT_FORCED_DUE, {reason: err.msg }), 'danger', this.getProviderDisplayName(provider), true)
         } else {
            this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOGGED_OUT_FORCED, 'danger', this.getProviderDisplayName(provider). true)
         }
      }

      this.scope.auth[provider].error = err.msg
      this.setAuthState(provider, this.$authEvents.LOGOUTAFTEREXPIRED)
      return this.clearAuthState(provider)
   }

   logoutAfterExpire(provider: any) {
      this.$log.debug('afterlogout ' + provider)
      if (this.authConfigs.keepAuthenticatedSessionAlive) {
         this.stopRefreshTimer(provider)
      }

      // no need to force broadcast. Rely on condition in function that checks for change in state.
      this.setAuthState(provider, this.$authEvents.LOGOUTAFTEREXPIRED)
      return this.clearAuthState(provider)
   }

   afterLogout(provider: any, forceBroadcast = false) {
      // set state and go back to where the user was
      this.$log.debug('afterlogout ' + provider)
      if (this.authConfigs.keepAuthenticatedSessionAlive) {
         this.stopRefreshTimer(provider)
      }

      this.setAuthState(provider, this.$authEvents.LOGOUTSUCCESS, forceBroadcast)
      return this.clearAuthState(provider)
   }

   clearAuthState(provider: any, optApplyPrevState = true) {
      this.setAuthValue(provider, null)
      this.scope.auth[provider].expiry = ''
      this.scope.auth[provider].user = ''
      this.scope.auth[provider].csrf = ''
      this.scope.auth[provider].loggedIn = false
      this.scope.auth[provider].accessToken = ''
      this.scope.auth[provider].accessExpiry = ''
      this.scope.auth[provider].username = ''
      this.scope.auth[provider].email = ''
      this.scope.loggedInStatusForBanner = false

      if (optApplyPrevState) {
         return this.optApplyPrevState()
      }
   }

   // this function also performs the logoutAfterExpire - so when login is expired, login details are removed
   isAuthExpired(provider: any, withinSeconds = 60) {
      if (this.getAuthState(provider) === this.$authEvents.LOGINEXPIRED) {
         this.$log.debug('auth expired - LOGINEXPIRED state found')
         this.logoutAfterExpire(provider)
         return true
      }

      // check on expiry date
      const date = parseInt(this.getAuthValue(provider, 'expiry'))
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      if (isNaN(parseInt(withinSeconds))) {
         throw new Error("param is not an integer")
      }
      if (isNaN(date)) { //nothing in localstorage, so assume expired
         this.$log.debug('auth expired - no date in localstorage')
         this.logoutAfterExpire(provider)
         return true
      }
      // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
      const isExpired = ((new Date(date * 1000) - new Date()) / 1000) < withinSeconds
      // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
      if (((new Date(date * 1000) - new Date()) / 1000) < 0) {
      // really expired...
         this.setAuthState(provider, this.$authEvents.LOGINEXPIRED)
      }

      this.$log.debug(`auth expired = ${isExpired}`)
      if (isExpired) {
         this.logoutAfterExpire(provider)
      }
      return isExpired
   }

   deleteAppState() {
      return this.setAppState(null)
   }

   storeAppState() {
      return this.setAppState(JSON.stringify(this.appState.takeSnapShot()))
   }

   getPreviousAppState() {
      try {
         return JSON.parse(this.getAppState())
      } catch (error) {
         return null
      }
   }

   optApplyPrevState() {
      const prevAppState = this.getPreviousAppState()
      if (prevAppState && !_.isEmpty(prevAppState)) {
         const setState = () => {
            return this.appState.params = prevAppState
         }

         this.appState.applyStateWithSnapShot(setState)
         return this.deleteAppState()
      }
   }

   afterLogIn(provider: any, data: any, refreshOnly = false) {
      // if no 'data' provided, it grabs the data we need from the store
      this.$log.debug(`afterlogin for: ${provider}, refreshing only: ${refreshOnly}`)

      if (data) {
      // adding human readable expiryToDate for debugging ;-)
         data.expiryToDate = new Date(parseInt(data.expiry) * 1000)
         // TODO this can go I think, there is no single logged in provider anymore...
         this.scope.provider = provider
         // and update scope
         this.scope.auth[provider].expiry = data.expiry
         this.scope.auth[provider].user = data.user
         this.scope.auth[provider].csrf = data.csrf
         this.scope.auth[provider].loggedIn = true
         this.scope.auth[provider].accessToken = data.access_token
         this.scope.auth[provider].accessExpiry = data.access_expiry
         this.scope.auth[provider].username = data.display_name
         this.scope.auth[provider].email = data.email
         this.scope.loggedInStatusForBanner = true
         this.$log.debug("afterLogin - got data: ", data)
         this.setAuthValue(provider, data)
      } else {
         this.$log.debug('afterLogin - grabbing from localstorage')
         this.updateScopeFromLocalStorage(provider)
      }

      if (this.authConfigs.keepAuthenticatedSessionAlive) {
         this.startRefreshTimer(provider)
      }

      if (!refreshOnly) {
         this.setAuthState(provider, this.$authEvents.LOGINSUCCESS, true)
         return this.optApplyPrevState()
      } else if(data) {
         this.$rootScope.$broadcast('csrfTokenRefreshed', {provider, csrf: data.csrf, user: data.user});
      }
   }

   loginSuccessHandler(event: any, data: any) {
      this.updateFeaturesWithLoginState()
      this.closeLoginDialog(data.provider)
      // Force a fresh authenticated search so restricted content (e.g. citation counts) appears immediately.
      // $route.reload() skips the API call when params haven't changed; calling apiService.search directly bypasses that guard.
      if (this.appState?.params && this.appState?.apiService) {
         return this.appState.apiService.search(this.appState.params)
      }
      return this.$route.reload()
   }

   // TODO check if it matters we re-use the modelInstance here
   closeLoginDialog(provider: any) {
      return this.uibModalInstance?.close(provider)
   }

   closeLogoutDialog(provider: any) {
      return this.uibModalInstance?.close(provider)
   }

   checkLogoutHappened(provider: any) {
      // now check, to be sure what current state is. Some providers do not have a redirect, so users will manually close this popup
      // then we need to check if we're still logged in, (might happen if they decide to not actually log out)
      return this.$log.info('Check if logout is needed?')
   }
   //@doValidateAfterCallback(provider)

   openLogoutDialog(feature: any, provider: any, redirectUrl: any) {
      const loggedInProvider = this.getLoggedInProviderForFeature(feature)
      if (!loggedInProvider) {
         this.$log.error('logout dialog called for feature but not logged in', feature, redirectUrl, loggedInProvider)
         this.alerts.toastAlert('authenticationNotice', this.i18n.translations.LOGGED_OUT_ALREADY, 'warning', this.getProviderDisplayName(loggedInProvider)(true))
         this.afterLogout(provider, true)
         return this.$q.resolve()
      }

      // do we need to give users reason for logout dialog too? Think about unclear stuff here?
      const reason = _(this.providers).some((p: any) => this.getAuthState(p) === this.$authEvents.LOGINEXPIRED) ? 'LOG_IN_EXPIRED' : ''
      this.uibModalInstance = this.$uibModal.open({
         templateUrl: '/assets/logoutDialog.html',
         controller: 'authenticationController',
         controllerAs: 'vm',
         resolve: {
            feature: () => feature,
            reason: () => reason,
            redirectUrl: () => redirectUrl,
            provider: () => ({provider: loggedInProvider, display: this.getProviderDisplayName(loggedInProvider), summonOnly: this.getSummonOnlyForProvider(loggedInProvider)})
         },
         backdrop: true,
         keyboard: true,
         windowClass: 'authentication-modal'
      })

      return this.uibModalInstance.result
         .then((res: any) => {
            return this.checkLogoutHappened(provider)
         }).catch((res: any) => { 
            return this.checkLogoutHappened(provider)
         })
   }

   openRetryDialog(feature: any, provider: any) {
      this.uibModalInstance = this.$uibModal.open({
         templateUrl: '/assets/retryLoginDialog.html',
         controller: 'authenticationController',
         controllerAs: 'vm',
         resolve: {
            feature: () => feature,
            provider: () => provider
         },
         backdrop: true,
         keyboard: true,
         windowClass: 'authentication-modal'
      })

      return this.uibModalInstance.result
   }

   getProviderDisplayName(providerNameOrObject: any) {
      if (typeof providerNameOrObject === 'object') {
         if (providerNameOrObject.displayName) {
            return providerNameOrObject.displayName
         } else { return '' }
      } else { 
         if (this.scope.auth[providerNameOrObject] && this.scope.auth[providerNameOrObject].displayName) {
            return this.scope.auth[providerNameOrObject].displayName
         } else { 
            return ''
         }
      }
   }

   openLoginDialog(feature: any, redirectUrl: any = this.$window.location.href) {
      const providers: { provider: string, display: string, canLoginManually: boolean, name: string }[] = []
      _.each(this.getProvidersForFeature(feature) || [], (provider: string) => {
         return providers.push({ provider, display: this.getProviderDisplayName(provider), canLoginManually: this.providerCanLoginManually(provider), name: provider})
      })
      const reason = _(this.providers).some((provider: any) => this.getAuthState(provider) === this.$authEvents.LOGINEXPIRED) ? 'LOG_IN_EXPIRED' : ''

      this.uibModalInstance = this.$uibModal.open({
         templateUrl: '/assets/institutionLoginDialog.html',
         controller: 'authenticationController',
         controllerAs: 'vm',
         resolve: {
            reason: () => reason,
            feature: () => feature,
            redirectUrl: () => redirectUrl,
            providers: () => providers
         },
         backdrop: true,
         keyboard: true,
         windowClass: 'authentication-modal'
      })

      return this.uibModalInstance.result
         .then((data: any) => {
            const loggedIn = this.getAuthState(data) === this.$authEvents.LOGINSUCCESS
            if (loggedIn && feature != "cloudStorage") {
               // redirect back to original route
               let route: string | null = null
               let hashIndex = redirectUrl.indexOf('#!')
               if (hashIndex !== -1) {
                  // standard AngularJS hashbang route, e.g. "#!/path?foo=bar"
                  route = redirectUrl.substring(hashIndex + 2)
               } else {
                  // fallback for routes that use "#/path?foo=bar" (no "!)
                  hashIndex = redirectUrl.indexOf('#/')
                  if (hashIndex !== -1) {
                     route = redirectUrl.substring(hashIndex + 1)
                  }
               }
               if (route) {
                  this.applyRouteFromString(route)
               }
            } else {
               return this.checkIfOnAuthRouteAndMoveAway()
            }
         })
   }

   /**
    * Parses a route string (e.g. "/path?foo=bar") and updates $location accordingly.
    * @param route Route string in the format "path?query"
    */
   private applyRouteFromString(route: string) {
      const [path, queryString] = route.split('?')
      this.$location.path(path)
      if (queryString) {
         const params: Record<string, string> = {}
         queryString.split('&').forEach((pair: string) => {
            if (!pair) return
            const [key, value] = pair.split('=')
            params[decodeURIComponent(key)] = decodeURIComponent(value || '')
         })
         this.$location.search(params)
      } else {
         this.$location.search({})
      }
   }
}


AuthenticationService.$inject = ['$window','configService', 'translationService', '$log', '$q', '$location', 'appStateService','$http', '$rootScope', '$authEvents', '$uibModal', '$timeout', '$route', '$interval', 'alertService', 'dialogService']

angular.module('summonApp.services')
   .service('authenticationService', AuthenticationService)
